export const common = {
  nav: {
    home: "Home",
    wms: {
      title: "WMS Warehouse System",
      ecommerce: "E-commerce Logistics WMS",
      thirdParty: "Third-Party Logistics WMS",
      hkGuide: "Hong Kong WMS Guide",
      selectionGuide: "WMS/TMS Selection Guide",
    },
    ecommerce_wms: "E-commerce WMS",
    logistics_wms: "3PL WMS",
    tms: {
      title: "TMS Transport System",
      fleet: "Fleet Management",
      address: "Smart Address Parsing",
      selectionGuide: "WMS/TMS Selection Guide",
    },
    erp: "ERP System",
    erpCaseStudies: "Case Studies",
    tplsp: "Third Party Logistics Subsidy Scheme",
    knowledge: "Knowledge Hub",
    knowledgeArticles: "Knowledge Articles",
    insights: "Logistics News Insights",
    about: "About",
    contact: "Contact Us",
    language: "EN",
  },
  hero: {
    title: "Hong Kong WMS, TMS & ERP Experts",
    subtitle:
      "Smart operations and logistics solutions for local businesses",
    description:
      "AUTOCHAIN provides WMS, TMS, and ERP systems to help businesses connect warehouse, transport, and management workflows with higher efficiency and lower operating costs.",
    cta: "Get Started",
    cta1: "Get Free Solution",
    cta2: "Book Demo",
    demo: "Book Demo",
  },
  painPoints: {
    title: "Are You Facing These Logistics Challenges?",
    warehouse: {
      title: "Warehouse Management Pain Points",
      pain1: "Inaccurate inventory data, frequent stockouts or overstocking",
      pain2: "Low manual operation efficiency, prone to errors",
      pain3: "Unable to track goods location and status in real-time",
      pain4: "Low warehouse space utilization, high costs",
    },
    transport: {
      title: "Transportation Management Pain Points",
      pain1:
        "Unable to track vehicle location and transport status in real-time",
      pain2: "Unreasonable route planning increases transportation costs",
      pain3: "Difficult driver management, complex salary calculations",
    },
    solution: "✅ AUTOCHAIN Smart Logistics System Solves All Pain Points!",
  },
  products: {
    title: "Our Solutions",
    subtitle:
      "From WMS and TMS to ERP, complete system support for business operations and logistics workflows",
    wms: {
      title: "WMS Warehouse Management System",
      description:
        "Intelligent warehouse management to improve inventory accuracy and operational efficiency",
      benefit:
        "✅ Improve warehouse efficiency by 40%, inventory accuracy up to 99.9%",
      cta: "Learn About WMS",
    },
    tms: {
      title: "TMS Transportation Management System",
      description:
        "Optimize transportation routes, reduce logistics costs, and improve delivery efficiency",
      benefit:
        "✅ Save 30% transportation costs, improve customer satisfaction",
      cta: "Learn About TMS",
    },
    erp: {
      title: "ERP Business Management System",
      description:
        "Integrate finance, purchasing, sales, inventory, and customer data into one clearer workflow",
      benefit:
        "✅ Simple to use and easy to adopt, ideal for Hong Kong companies moving beyond spreadsheets",
      cta: "Learn About ERP",
    },
  },
  integration: {
    title: "WMS + TMS Integration Power",
    effect: "1 + 1 > 2 Synergy Effect",
    description:
      "When WMS and TMS systems are perfectly integrated, your logistics business will achieve unprecedented efficiency improvements. From order receipt to final delivery, every link can be seamlessly connected, creating greater business value for you.",
    steps: {
      step1: {
        title: "Order Receipt",
        desc: "Automatically receive and analyze orders",
      },
      step2: {
        title: "WMS Processing",
        desc: "Intelligent inventory allocation and picking",
      },
      step3: {
        title: "TMS Dispatch",
        desc: "Optimize routes and vehicle arrangements",
      },
      step4: {
        title: "Customer Notification",
        desc: "Real-time delivery status updates",
      },
    },
  },
  features: {
    title: "Core Features",
    subtitle: "Comprehensive Smart Logistics Management",
    wms: {
      title: "WMS Warehouse Management System",
      description:
        "Intelligent warehouse management to improve inventory accuracy and operational efficiency",
    },
    tms: {
      title: "TMS Transportation Management System",
      description:
        "Optimize transportation routes, reduce logistics costs, and improve delivery efficiency",
    },
    ai: {
      title: "AI Smart Analytics",
      description:
        "Utilize artificial intelligence to predict demand and optimize inventory allocation",
    },
  },
  benefits: {
    title: "Why Choose AUTOCHAIN",
    subtitle: "Professional Logistics Technology Solutions",
    efficiency: "Improve Efficiency",
    efficiencyDesc:
      "Automated processes reduce human errors and improve operational efficiency by 40%",
    cost: "Reduce Costs",
    costDesc:
      "Optimize inventory management and transportation routes, saving 30% operational costs",
    accuracy: "Precise Management",
    accuracyDesc:
      "Real-time tracking and data analysis with 99.9% inventory accuracy",
    support: "Professional Support",
    supportDesc: "24/7 technical support ensuring stable system operation",
  },
  testimonials: {
    title: "Customer Testimonials",
    subtitle: "See what our customers say",
    customer1: {
      name: "Manager Zhang",
      role: "CaseTify Logistics Director",
      quote:
        "After using AUTOCHAIN's WMS system, our inventory accuracy improved to 99.8%, greatly reducing stockout situations.",
    },
    customer2: {
      name: "Director Li",
      role: "Hong Kong Bakery Operations Director",
      quote:
        "The TMS system helped us optimize delivery routes, reducing transportation costs by 25% and significantly improving customer satisfaction.",
    },
    customer3: {
      name: "Manager Wang",
      role: "San-Legend Global Warehouse Manager",
      quote:
        "The integrated WMS+TMS solution made our logistics operations smoother, improving efficiency by 40%.",
    },
  },
  howItWorks: {
    title: "How to Get Started",
    subtitle: "Four simple steps to begin your smart logistics journey",
    step1: "Needs Analysis",
    step1Desc:
      "Our expert team thoroughly understands your business requirements",
    step2: "Solution Design",
    step2Desc: "Customize the most suitable logistics solution for you",
    step3: "System Deployment",
    step3Desc: "Rapid system deployment with comprehensive training support",
    step4: "Continuous Optimization",
    step4Desc:
      "Continuous monitoring and optimization to ensure optimal results",
    description:
      "Our professional team will accompany you throughout the process, ensuring smooth system launch and maximum benefits.",
    cta: "Get Started Now",
  },
  partners: {
    title: "Trusted Partners",
    subtitle: "Many renowned companies choose AUTOCHAIN",
  },
  finalCta: {
    title: "Ready to Start Your Smart Logistics Journey?",
    description:
      "Contact us now for professional logistics solution consultation and take your business to the next level.",
    requirements: "We only need the following basic information:",
    req1: "Contact Name",
    req2: "Phone Number",
    req3: "Company Name",
    contact: "Or call directly: +852 9425 2903",
  },
  contactForm: {
    title: "Contact Us",
    subtitle: "Fill out the form and we will contact you within 24 hours",
    name: "Name",
    namePlaceholder: "Please enter your name",
    company: "Company Name",
    companyPlaceholder: "Please enter company name",
    email: "Email",
    emailPlaceholder: "Please enter email",
    phone: "Phone",
    phonePlaceholder: "Please enter phone number",
    message: "Requirements Description",
    messagePlaceholder: "Please describe your specific requirements...",
    submit: "Submit Inquiry",
    submitSuccess:
      "Submitted successfully! We will contact you within 24 hours.",
    submitError:
      "Submission failed, please try again later or contact us directly.",
  },
  cta: {
    title: "Ready to Start Your Smart Logistics Journey?",
    subtitle: "Contact us now for professional logistics solution consultation",
    button: "Free Consultation",
  },
  footer: {
    company: "AUTOCHAIN TECHNOLOGY",
    description: "Professional Smart Logistics Solutions Provider",
    quickLinks: "Quick Links",
    contact: "Contact Information",
    address: "Kwun Tong, Kowloon, Hong Kong",
    phone: "+852 9425 2903",
    email: "info@autochain.tech",
    copyright: "© 2024 AUTOCHAIN TECHNOLOGY. All rights reserved.",
  },
  aboutUs: {
    title: "About AUTOCHAIN",
    subtitle: "Hong Kong Local Logistics Technology Expert",
    story: "Our Story",
    storyContent:
      "AUTOCHAIN was founded in Hong Kong by a professional team with over 15 years of logistics industry experience. We deeply understand the challenges that Hong Kong SMEs face in logistics management—from limited warehouse space, staff shortages, to high transportation costs and customer demands for same-day delivery. That's why we are committed to developing a smart logistics system that truly meets local market needs.",
    mission: "Our Mission",
    missionContent:
      "To make enterprise-grade logistics management technology accessible to every Hong Kong business. We believe that quality logistics systems should not be exclusive to large corporations. Through cloud technology and flexible pricing models, we enable SMEs to improve logistics efficiency at reasonable costs and stand out in a competitive market.",
    team: "Professional Team",
    teamContent:
      "Our team members come from diverse fields including logistics, technology, and supply chain management, having served both local and multinational logistics enterprises. We understand every detail of daily warehouse operations, know the various situations drivers encounter on the road, and clearly understand the cost and efficiency concerns that business owners care about most.",
    values: {
      title: "Our Values",
      local: {
        title: "Localization",
        desc: "System designed specifically for Hong Kong market, supporting Traditional Chinese, local address formats, and integration with Hong Kong courier services",
      },
      practical: {
        title: "Practicality First",
        desc: "Features designed based on actual needs, no unnecessary complex functions, quick to learn and easy to use",
      },
      support: {
        title: "Dedicated Support",
        desc: "Local team provides Cantonese/Mandarin support, immediate response to issues, no waiting for overseas customer service",
      },
      flexible: {
        title: "Flexibility",
        desc: "Pay-as-you-go, no large upfront investment required, system scales as your business grows",
      },
    },
  },
  industries: {
    title: "Industry Solutions",
    subtitle: "Different industries, same professional logistics solutions",
    ecommerce: {
      title: "E-commerce Retail",
      desc: "Support multi-platform order integration (HKTVmall, Shopify, own webstore), automatic inventory sync, rapid processing of large order volumes. Handle peak seasons with ease, ensuring on-time shipments.",
      features: [
        "Multi-platform order integration",
        "Automatic inventory sync",
        "Batch shipment processing",
        "Returns management",
      ],
    },
    food: {
      title: "Food & Beverage",
      desc: "For time-sensitive goods like fresh produce, frozen meat, and F&B ingredients, we provide temperature tracking, FIFO management, expiry date alerts, and other features to ensure food safety compliance.",
      features: [
        "Expiry date management",
        "First In First Out (FIFO)",
        "Temperature records",
        "Batch traceability",
      ],
    },
    manufacturing: {
      title: "Manufacturing",
      desc: "End-to-end management from raw material receiving, WIP management, to finished goods shipping. Support BOM, production material requisition, quality inspection, seamlessly integrated with production processes.",
      features: [
        "Raw material management",
        "BOM management",
        "Production requisition",
        "Quality inspection",
      ],
    },
    thirdParty: {
      title: "Third-Party Logistics (3PL)",
      desc: "Multi-client, multi-warehouse management with independent billing and reporting. Support value-added services management (labeling, repacking, kitting) to help 3PL companies improve service quality and profitability.",
      features: [
        "Multi-client management",
        "Independent billing reports",
        "Value-added services",
        "Client portal",
      ],
    },
    medical: {
      title: "Medical Logistics",
      desc: "GDP-compliant warehouse management supporting drug batch tracking, expiry management, temperature and humidity monitoring, recall management, ensuring drug safety and compliance.",
      features: [
        "Batch tracking",
        "Expiry management",
        "Temperature monitoring",
        "Recall management",
      ],
    },
    furniture: {
      title: "Furniture & Appliances",
      desc: "Special handling requirements for large items, supporting delivery time slot booking, upstairs service arrangement, installation tracking, old appliance recycling, enhancing customer experience.",
      features: [
        "Delivery time slots",
        "Upstairs service",
        "Installation tracking",
        "Old item recycling",
      ],
    },
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Answers to your most important questions",
    questions: {
      q1: {
        question: "How is the system implemented? How long does it take?",
        answer:
          "We provide full implementation support services. Typically, the basic system can be deployed and trained within 1-2 weeks; if data migration or customization is needed, it takes about 3-4 weeks. Our professional team will assist with existing data import, staff training, system debugging, ensuring a smooth transition.",
      },
      q2: {
        question: "Can it integrate with my existing ERP/accounting system?",
        answer:
          "Yes. AUTOCHAIN provides standard API interfaces, supporting integration with mainstream ERP systems (such as SAP, Oracle, Yonyou, Kingdee), accounting software (such as Xero, QuickBooks), e-commerce platforms (such as Shopify, WooCommerce), etc. Our technical team will help assess integration requirements and provide solutions.",
      },
      q3: {
        question: "What is the pricing model?",
        answer:
          "We use a SaaS subscription model, charged monthly or annually, with no large upfront investment required. Fees are calculated based on feature modules and usage (such as number of users, order volume, number of warehouses). We offer a free trial period so you can experience before deciding. For detailed quotes, please contact our sales team.",
      },
      q4: {
        question: "How is data security ensured?",
        answer:
          "We use bank-grade encryption technology (SSL/TLS) to protect data transmission, all data is stored in internationally certified cloud data centers with regular security audits and backups. The system supports multi-factor authentication, permission management, operation logs, and other security features to ensure your business data is secure.",
      },
      q5: {
        question: "What languages does the system support?",
        answer:
          "The system interface supports Traditional Chinese, Simplified Chinese, and English, switchable at any time. Reports and label printing also support multi-language output, convenient for handling cross-border business.",
      },
      q6: {
        question: "Is there a mobile app?",
        answer:
          "Yes. We provide a dedicated driver app (supporting iOS and Android) for receiving tasks, navigation, photo proof of delivery, etc. Warehouse staff can use mobile phones or tablets for barcode scanning operations. Management can view reports and system status anytime through mobile browsers.",
      },
      q7: {
        question: "How do I get support if I encounter problems?",
        answer:
          "We provide multiple support channels: email support (all plans), WhatsApp instant messaging, phone support (Professional and above), dedicated account manager (Enterprise). Local team provides Cantonese/Mandarin support, general inquiries responded within 24 hours, urgent issues handled immediately.",
      },
      q8: {
        question: "Can I try before deciding?",
        answer:
          "Of course. We offer a 14-day free trial, no credit card required. During the trial, you can experience all features, and our team will help you set up the system and import test data. After the trial ends, you can choose to subscribe or cancel, absolutely no pressure.",
      },
    },
  },
  wmsFeatures: {
    title: "WMS Core Feature Modules",
    subtitle: "Comprehensive coverage of every warehouse management aspect",
    inbound: {
      title: "Inbound Management",
      desc: "Support multiple inbound types including purchase receiving, returns receiving, and transfer receiving. Barcode verification, automatic storage location assignment, batch management all included, ensuring accurate and efficient receiving.",
    },
    inventory: {
      title: "Inventory Management",
      desc: "Real-time inventory queries, multi-dimensional inventory reports, inventory alerts, stocktaking management. Support batch management, serial number management, expiry date management to meet different industry needs.",
    },
    picking: {
      title: "Picking & Packing",
      desc: "Intelligent picking path planning, wave picking, pick-and-sort. Support multiple packaging standards, automatic packaging material calculation, print packing lists and shipping labels.",
    },
    outbound: {
      title: "Outbound Management",
      desc: "Automatic order allocation, batch outbound processing, outbound verification. Support multiple outbound strategies (FIFO, FEFO, specified batch), ensuring accurate shipments.",
    },
    courier: {
      title: "Courier Integration",
      desc: "One-click integration with SF Express, Kerry, DHL and other major couriers, automatic waybill generation, shipping label printing, logistics tracking, significantly improving shipping efficiency.",
    },
    reporting: {
      title: "Reporting & Analytics",
      desc: "Inventory turnover rate, picking efficiency, inbound/outbound statistics and other multi-dimensional reports. Data visualization dashboard helps management instantly grasp warehouse operations.",
    },
  },
  tmsFeatures: {
    title: "TMS Core Feature Modules",
    subtitle: "From order to delivery, intelligent management throughout",
    routing: {
      title: "Smart Routing",
      desc: "AI algorithms automatically plan optimal routes, considering traffic conditions, delivery time windows, vehicle capacity and other factors. Three routing modes to choose from, significantly saving routing time and transportation costs.",
    },
    tracking: {
      title: "Real-time Tracking",
      desc: "GPS positioning displays vehicle location in real-time, delivery status updates instantly. Customers receive delivery notifications and estimated arrival times, enhancing service experience.",
    },
    driver: {
      title: "Driver Management",
      desc: "Driver information, licenses, scheduling all in one place. Performance tracking, salary calculation automated, supporting multiple calculation methods including by mileage, by delivery, by hourly rate.",
    },
    vehicle: {
      title: "Fleet Management",
      desc: "Complete records of vehicle information, maintenance history, fuel consumption monitoring. Automatic maintenance reminders, inspection reminders, ensuring safe fleet operations.",
    },
    pod: {
      title: "Electronic Proof of Delivery",
      desc: "Driver app photo capture, customer electronic signature confirmation. All POD records automatically archived, documented evidence, reducing delivery disputes.",
    },
    analytics: {
      title: "Data Analytics",
      desc: "Key metrics like on-time rate, delivery costs, driver performance at a glance. Data-driven decisions for continuous transportation efficiency optimization.",
    },
  },
  tplsp: {
    title: "Third Party Logistics Service Providers Subsidy Scheme",
    subtitle: "TPLSP - Hong Kong Government Funding Scheme",
    description:
      'To maintain the competitiveness of Hong Kong\'s logistics industry, the Hong Kong SAR Government established the "Third Party Logistics Service Providers Subsidy Scheme" on October 12, 2020, to encourage the logistics industry to improve efficiency and productivity through technology applications.',
    seo: {
      title:
        "Third Party Logistics Subsidy Scheme TPLSP | Hong Kong Government Funding | AUTOCHAIN",
      description:
        "Third Party Logistics Service Providers Subsidy Scheme (TPLSP) provides up to HK$2 million funding to support logistics technology applications. AUTOCHAIN provides free application guidance.",
      keywords:
        "Third Party Logistics Subsidy Scheme,TPLSP,Hong Kong Government Funding,Logistics Technology,WMS,TMS,Warehouse Management System,Transportation Management System",
    },
    updates: {
      title: "Latest Enhancement Measures (Effective from February 1, 2024)",
      subsidy_increase:
        "Increased subsidy ceiling: The cumulative subsidy ceiling per applicant enterprise increased from HK$1 million to HK$2 million",
      scope_expansion:
        "Expanded subsidy scope: Covers Environmental, Social and Governance (ESG) technology solutions and related application services, including consultancy services",
      training_support:
        "New training subsidy: Subsidy scope expanded to include project training related to technology applications",
    },
    overview: {
      title: "Scheme Overview",
      duration: "Project Duration",
      duration_value: "0-24 months",
      subsidy_ratio: "Subsidy Ratio",
      subsidy_ratio_value: "50% of total approved project expenditure",
      max_amount: "Cumulative Subsidy Amount",
      max_amount_value: "HK$2,000,000 maximum ceiling",
      max_projects: "Number of Projects",
      max_projects_value: "Maximum 4 projects can be subsidized",
    },
    eligibility: {
      title: "Eligibility Criteria",
      description:
        "Non-listed enterprises registered in Hong Kong under the Business Registration Ordinance (Chapter 310) and meeting the following conditions may submit applications:",
      condition1:
        "Providing third-party logistics services, such as supply chain and distribution management value-added services",
      condition2:
        "Business must be related to import or export logistics services",
      condition3:
        "Must maintain eligibility conditions during the project period",
    },
    funding: {
      title: "Funding Method",
      first_payment: "First Payment",
      first_payment_desc:
        "Successful applicants can receive 50% of the total approved funding as the first project payment after signing the funding agreement",
      final_payment: "Final Payment",
      final_payment_desc:
        "Final payment will be disbursed after the following conditions are met:",
      final_condition1: "Project completion",
      final_condition2:
        "Final report accepted by the Management Committee and Secretariat",
    },
    scope: {
      title: "Main Subsidy Scope",
      description:
        "Application projects must improve the productivity and efficiency of logistics value-added services through technology applications and/or information systems",
      subtitle: "Examples of logistics technology applications:",
      automation:
        "Automation equipment, mechanical equipment and artificial intelligence technology applications",
      edi: "Electronic Data Interchange and Interconnection Systems (EDI)",
      tms: "Transportation Management System (TMS)",
      erp: "Enterprise Resource Planning System (ERP)",
      analytics: "Logistics and supply chain analysis systems",
      infrastructure: "Technology network infrastructure",
      wms: "Warehouse/Cargo Distribution Center Management System (WMS)",
      rtls: "Real-Time Location System (RTLS)",
      iot: "Internet of Things (IoT) and RFID technology applications",
      security:
        "Regulated Agent Cargo Screening Facilities (RACSFs) X-ray inspection equipment",
    },
    process: {
      title: "Application Process",
      step1: "Prepare Documents",
      step1_desc:
        "Prepare business registration certificate and related business proof documents",
      step2: "Submit Application",
      step2_desc: "Fill out application form and submit required documents",
      step3: "Review and Assessment",
      step3_desc:
        "Management Committee reviews applications and conducts assessments",
      step4: "Approved Funding",
      step4_desc: "Receive first payment after signing agreement",
    },
    diy: {
      title: "No Need for Consultant Fees! You Can Apply Yourself!",
      subtitle:
        "Autochain provides free guidance to help you apply for funding yourself",
      step1: {
        title: "Step 1: HKPC Account Application",
        desc: "1) First check eligibility through HKPC eligibility check\n2) Create account through application system",
        link: "https://bee.hkpc.org/tc/funding-schemes/tplsp/",
      },
      step2: {
        title: "Step 2: Fill Application Form (Project Proposal)",
        desc: "The project proposal is the core of approval. Need to clearly explain: existing logistics operation pain points, how the project solves problems (what third-party logistics services and technologies to adopt), expected benefits (quantitative indicators such as cost reduction, efficiency improvement, error reduction) and project implementation timeline. Contact us for proposal guidelines and templates.",
      },
      step3: {
        title: "Step 3: RFQ to Obtain Quotations and Submit Application",
        desc: "Obtaining sufficient quotations is also a major hurdle in the application process. A clear RFQ will definitely save you a lot of back-and-forth communication time.",
      },
    },
    cta: {
      title: "Ready to Apply for Third Party Logistics Subsidy Scheme?",
      description:
        "If you need project proposal template and RFQ template, please contact our team!",
      whatsapp: "WhatsApp Consultation",
      phone: "Call for Inquiry",
      phone_number: "(852) 9425 2903",
      email: "sales@autochain.com.hk",
    },
  },
  privacy: {
    title: "Privacy Policy",
    lastUpdated: "Last Updated: February 2024",
    intro:
      "AUTOCHAIN TECHNOLOGY (hereinafter referred to as 'we') values your privacy. This Privacy Policy explains how we collect, use, store, and protect the personal information you provide when using our WMS (Warehouse Management System) application.",
    section1: {
      title: "1. Information We Collect",
      content:
        "When you use the WMS application, we may collect the following types of information:",
      item1:
        "Account Information: including your name, email address, phone number, and company information",
      item2:
        "Warehouse Operations Data: including inventory records, order data, goods information, and related business data",
      item3:
        "Device Information: including device model, operating system version, unique device identifiers",
      item4:
        "Usage Data: including information about how you use the application, such as feature usage records and operation logs",
      item5:
        "Location Data: with your authorization, we may collect device location information to provide relevant services",
    },
    section2: {
      title: "2. Purpose of Data Use",
      content:
        "The information we collect will be used for the following purposes:",
      item1: "Providing and maintaining core functions of the WMS application",
      item2:
        "Improving and optimizing application performance and user experience",
      item3: "Providing customer support and technical assistance",
      item4:
        "Conducting system security monitoring and preventing fraudulent activities",
    },
    section3: {
      title: "3. Data Sharing and Disclosure",
      content:
        "We do not sell, rent, or trade your personal information to third parties. We only share your information under the following circumstances: with your explicit consent, to comply with legal requirements or court orders, to protect our legitimate interests and user safety.",
    },
    section4: {
      title: "4. Data Security",
      content:
        "We take appropriate technical and organizational measures to protect your personal information, including:",
      item1: "Using encryption technology to protect data transmission",
      item2: "Implementing access control and authentication mechanisms",
      item3: "Conducting regular security audits and system updates",
    },
    section5: {
      title: "5. Data Retention",
      content:
        "We only retain your personal information for the period necessary to achieve the purposes stated in this policy. When the data is no longer needed, we will securely delete or anonymize it.",
    },
    section6: {
      title: "6. Your Rights",
      content:
        "You have the right to access, correct, or delete your personal information. To exercise these rights, please contact us using the contact information below.",
    },
    section7: {
      title: "7. Contact Us",
      content:
        "If you have any questions about this Privacy Policy or need assistance, please contact us:",
    },
    contact: {
      company: "Company Name:",
      email: "Email:",
      phone: "Phone:",
    },
  },
  deleteAccount: {
    title: "Account Deletion Request",
    warningTitle: "Important Notice",
    warningMessage:
      "Once your account is deleted, all your data will be permanently removed, including inventory records, order history, and all related data. This action cannot be undone.",
    email: "Registered Email Address",
    emailPlaceholder: "Enter your registered email",
    phone: "Registered Phone Number",
    phonePlaceholder: "Enter your registered phone number",
    reason: "Reason for Deletion (Optional)",
    reasonSelect: "Please select a reason",
    reason1: "No longer using this service",
    reason2: "Privacy concerns",
    reason3: "Switched to another service",
    reason4: "Other reasons",
    confirmLabel:
      "I confirm that I want to delete my account and understand that this action cannot be undone and all data will be permanently deleted.",
    submitButton: "Submit Deletion Request",
    processingTime:
      "We will process your request within 7 business days and notify you via email.",
    successTitle: "Request Submitted",
    successMessage:
      "We have received your account deletion request. We will process it within 7 business days and notify you of the result via email.",
    submitError:
      "Submission failed. Please try again later or contact us directly.",
  },
};
